module.exports = __webpack_public_path__ + "img/Boy or Girl Page.1e23f807.jpg";